export const SET_PATIENT_DATA = 'SET_PATIENT_DATA';
export const RESET_PATIENT_DATA = 'RESET_PATIENT_DATA';
export const SET_SELECTED_PATIENT_DATA = 'SET_SELECTED_PATIENT_DATA';
export const SET_PATIENT_DATA_CURRENT_CYCLE= 'SET_PATIENT_DATA_CURRENT_CYCLE'
export const SET_PATIENT_UPLOADED_FILES = 'SET_PATIENT_UPLOADED_FILES'
export const DELETE_PATIENT_UPLOADED_FILES = 'DELETE_PATIENT_UPLOADED_FILES'
export const setPatientData = (keyPath, value) => ({
  type: SET_PATIENT_DATA,
  payload: { keyPath, value },
});

export const setPatientDataCurrentCycle = (data) => ({
  type: SET_PATIENT_DATA_CURRENT_CYCLE,
  payload: data,
});


export const resetPatientData = () => ({
  type: RESET_PATIENT_DATA,
});

export const setSelectedPatientData = (data) => ({
  type: SET_SELECTED_PATIENT_DATA,
  payload: data,
})

export const setPatientUploadedFiles = (data) => ({
  type: SET_PATIENT_UPLOADED_FILES,
  payload: data,
})

export const deletePatientUploadedFiles = (data) => ({
  type: DELETE_PATIENT_UPLOADED_FILES,
  payload: data,
})